import React from 'react'
import HeaderBlock from '../../cms-page-blocks/header-block'

const EditPageHeader = props => (
  <HeaderBlock cmsPageId={props.params.cmsPageId} />
)

export default EditPageHeader
